import { connect } from 'react-redux';
import actions from 'actions/InCall/InCallVideo';
import {
  inlinePresentationSelector,
  popoutPresentationSelector
} from 'selectors/call';
import { VIDEO_SECONDARY } from 'constants/InCall/InCallVideo';
import CallPresentation from 'components/InCall/CallPresentation/CallPresentation';
import _get from 'lodash/get';

const mapActionCreators = dispatch => ({
  updateVideoRatio: videoId => dispatch(actions.updateVideoRatio(videoId)),
  onResizeVideo: (videoId, videoSize) => dispatch(actions.onResizeVideo(videoId, videoSize)),
});

const mapStateToProps = (state) => {
  const videoLayout = _get(state, 'app.inCallVideo.videoLayout');
  const popoutPresentation = popoutPresentationSelector(state);
  const inlinePresentation = inlinePresentationSelector(state);
  const presentationContainerWidth = _get(videoLayout, ['videos', VIDEO_SECONDARY, 'container']);
  const presentationWidth = _get(videoLayout, ['videos', VIDEO_SECONDARY, 'width']);
  const presentationAvailable = _get(state, 'app.inCallVideo.presentationAvailable');

  return ({
    isMinimized: _get(state, 'app.inCallVideo.isMinimized'),
    presentationElementId: VIDEO_SECONDARY,
    presentationWidth,
    presentationContainerWidth,
    inlinePresentation,
    popoutPresentation,
    presentationAvailable,
  });
};

export default connect(mapStateToProps, mapActionCreators)(CallPresentation);
